import loadable from "@loadable/component";
import { ErrorBoundary } from "../../../components";
import FullPageLoader from "@Components/FullPageLoader";

const ShortlistDesktopParent = loadable(() => import("./ShortlistDesktop"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => (
  <ErrorBoundary>
    <ShortlistDesktopParent {...props} />
  </ErrorBoundary>
);
